var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _ from 'lodash';
export function findById(array, id) {
    return array.find(function (x) { return x.id === id; });
}
export function deleteById(array, id) {
    var itemToRemove = array.find(function (x) { return x.id === id; });
    if (itemToRemove) {
        array.remove(itemToRemove);
    }
}
// Source https://github.com/granteagon/move
export function move(array, moveIndex, toIndex) {
    /* #move - Moves an array item from one position in an array to another.
       Note: This is a pure function so a new array will be returned, instead
       of altering the array argument.
      Arguments:
      1. array     (String) : Array in which to move an item.         (required)
      2. moveIndex (Object) : The index of the item to move.          (required)
      3. toIndex   (Object) : The index to move item at moveIndex to. (required)
    */
    var item = array[moveIndex];
    var length = array.length;
    var diff = moveIndex - toIndex;
    if (diff > 0) {
        // move left
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(array.slice(0, toIndex)), false), [
            item
        ], false), __read(array.slice(toIndex, moveIndex)), false), __read(array.slice(moveIndex + 1, length)), false);
    }
    if (diff < 0) {
        // move right
        var targetIndex = toIndex + 1;
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(array.slice(0, moveIndex)), false), __read(array.slice(moveIndex + 1, targetIndex)), false), [
            item
        ], false), __read(array.slice(targetIndex, length)), false);
    }
    return array;
}
var arrayPrototype = Object.getPrototypeOf([]);
export function isArray(value) {
    return Object.getPrototypeOf(value) === arrayPrototype;
}
/**
 * Pads the array that the length is a multiple of the given multiple
 * @param array
 * @param multiple the multiple factor
 * @param fillItem optional, push empty item if undefined
 */
export function padArray(array, multiple, fillItem) {
    var padFunction = fillItem === undefined
        ? function () { array.length++; }
        : function () { array.push(fillItem); };
    while (array.length % multiple !== 0) {
        padFunction();
    }
}
export function mapChunks(array, chunkLength, mappingCallback) {
    var chunks = _.chunk(array, chunkLength);
    var mappedChunks = chunks.map(mappingCallback);
    return mappedChunks;
}
export function bitArrayToString(bits) {
    var bitsChars = bits.map(function (bit) { return bit === true ? '1' : '0'; });
    // reverse because the first bit must be on the right side
    var bitsString = bitsChars.reverse().join('');
    return bitsString;
}
//# sourceMappingURL=ArrayHelpers.js.map